import { computed } from "@vue/composition-api";
import Store from "@/store";
import { MUTATION_TYPES } from "@/store/const";

export default function useDoNotDisturb() {
  const doNotDisturb = computed(() => Store.state.doNotDisturb);
  const setDoNotDisturb = (state: boolean) => {
    Store.commit(MUTATION_TYPES.SET_DO_NOT_DISTURB, state);
    return doNotDisturb.value;
  };
  return {
    doNotDisturb,
    setDoNotDisturb,
  };
}
